import { IOException1wyutdmfe71nu as IOException } from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ConnectTimeoutExceptionClass;
function ConnectTimeoutException() {
  if (ConnectTimeoutExceptionClass === VOID) {
    class $ extends IOException() {}
    initMetadataForClass($, 'ConnectTimeoutException');
    ConnectTimeoutExceptionClass = $;
  }
  return ConnectTimeoutExceptionClass;
}
var SocketTimeoutExceptionClass;
function SocketTimeoutException() {
  if (SocketTimeoutExceptionClass === VOID) {
    class $ extends InterruptedIOException() {}
    initMetadataForClass($, 'SocketTimeoutException');
    SocketTimeoutExceptionClass = $;
  }
  return SocketTimeoutExceptionClass;
}
var InterruptedIOExceptionClass;
function InterruptedIOException() {
  if (InterruptedIOExceptionClass === VOID) {
    class $ extends IOException() {}
    initMetadataForClass($, 'InterruptedIOException');
    InterruptedIOExceptionClass = $;
  }
  return InterruptedIOExceptionClass;
}
//region block: exports
export {
  ConnectTimeoutException as ConnectTimeoutException35w4gpuoa1015,
  SocketTimeoutException as SocketTimeoutException2zstjwq2yf3s9,
};
//endregion

//# sourceMappingURL=TimeoutExceptions.nonJvm.mjs.map
